const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path fill-rule="evenodd" d="M2.897 3.153a.2.2 0 0 1 .256-.256l18.42 6.651a.6.6 0 0 1 .078 1.094l-6.911 3.686a1 1 0 0 0-.412.412l-3.686 6.91a.6.6 0 0 1-1.094-.078zm2.351 2.095 5.023 13.91 2.948-5.527a1 1 0 0 1 .412-.412l5.527-2.948z" clip-rule="evenodd"/></svg>';
export {
  e as w
};
